import React from "react"
import { Row, Col } from "react-bootstrap"
import { css } from "@emotion/core"

import { mq } from "../utils/media-queries"
import QuestionsHeaderIcon from "../assets/images/questions-header-icon.svg"
import purpleGradientArrow from '../assets/images/about/purpleGradientArrow.png'

const QuestionsToAsk = () => {
  return (
    <section
      css={css`
        padding: 0 15px;
      `}
    >
      <Row>
        <Col>
          <div css={css`
            background: linear-gradient(180deg, #81419B 0%, #A855C8 100%);
            box-shadow: 2px 3px 4px 0 rgba(0,0,0,0.35);
            border-radius: 8px;
            font-size: 18px;
            line-height: 22px;
            font-weight: bold;
            width: 559px;
            height: 131px;
            margin: 0 auto 30px;
            font-family: Arial, sans-serif;
            text-transform: uppercase;
            ${[mq[2]]} {
              height: 84px;
              width: 100%;
              font-size: 15px;
              line-height: 18px;
              img {
                width: 50px;
              }
            }
          `}
          >
            <a href="/hodgkin-lymphoma-treatment-discussion-guide"
              target="_self"
              // rel="noopener noreferrer"
              css={css`
                padding: 15px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                height: 100%;
                &:hover {
                  text-decoration: none;
                }
              `}
            >
              <div>
                <img loading='lazy' alt=""
                  css={css`
                width: 95px;
                margin-left: 15px;
                ${[mq[2]]} {
                  width: 70px;
                }
              `}
                  src={QuestionsHeaderIcon} />
              </div>
              <div
                css={css`
                  color: white;
                  text-align: center;
                  display: inline-block;
                `}
              >
                Hodgkin Lymphoma<br />Treatment Discussion<br />Guide
              </div>
              <img
                loading='lazy' alt=""
                css={css`
                width: 77px;
                margin-right: 15px;
                ${[mq[2]]} {
                  width: 70px;
                }
              `}
                src={purpleGradientArrow} />
            </a>
          </div>
        </Col>
      </Row>
    </section>
  )
}

export default QuestionsToAsk
